import layoutBiReportsView from './layoutBiReportsComponent.html';
import './layoutBiReportsComponent.css';

export function layoutBiReportsComponent() {
	return {
		transclude: true,
		bindings: {
			breadcrumbs: '<?',
		},
		controllerAs: 'vm',
		controller: layoutBiReportsComponentCtrl,
		template: layoutBiReportsView,
	};
}

class layoutBiReportsComponentCtrl {
	constructor(Theme, Cfg) {
		'ngInject';
		this.Theme = Theme;
		this.displayKnowledgebaseLink = Boolean(Number(Cfg.read('KnowledgebaseLink.Display')));
		this.knowledgebaseLinkUrl = Cfg.read('KnowledgebaseLink.Analytics.Page');
	}

	$onInit() {
		// handle logo
		this.logoUrl = this.Theme.img('on-light.png');
		// setup breadcrumbs
		this.breadcrumbLinks = [...this.breadcrumbs];
		this.lastBreadcrumb = this.breadcrumbLinks.pop();
	}
}
